import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const fetchProfileEmploymentStatus = createAsyncThunk(
    "profile/fetchProfileEmploymentStatus",
    async () => {
        try {
            const response = await axiosInstance({
                method: "get",
                url: "/profileEmploymentStatus"
            });
            return response.data.data;
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
);
